import { VisionWindowManager } from './manager';
import { VisionWindow } from './window';

export class VisionEventRulesWindow extends VisionWindow {
    private layout!: dhtmlXLayoutObject;
    private sideBar!: dhtmlXSideBar;
    private rulesListGrid!: dhtmlXGridObject;

    private descriptionForm!: dhtmlXForm;
    private geofenceGrid!: dhtmlXGridObject;
    private definitionsGrid!: dhtmlXGridObject;

    constructor(manager: VisionWindowManager) {
        super(manager, {
            id: 'edit_event_rule_window',
            title: 'Event Rules',
            x: 50,
            y: 50,
            width: 800,
            height: 600,
        });
        this.window.setText('Event Rules');
        this.modal = true;

        this.buildLayout();
    }

    /**
     *
     */
    private buildLayout(): void {
        this.layout = this.window.attachLayout('2U');
        this.layout.cells('a').setText('Rules');
        this.layout.cells('a').setWidth(200);

        this.rulesListGrid = this.layout.cells('a').attachGrid();
        this.rulesListGrid.setHeader('Name,Type,Assets', '', []);
        this.rulesListGrid.init();

        this.layout.cells('b').setText('Configuration');
        this.sideBar = this.layout.cells('b').attachSidebar();

        this.sideBar.addItem({
            id: 'rule_description',
            text: 'Description',
            icon: 'icons/information.png',
        });
        this.sideBar.addItem({
            id: 'rule_applies_to',
            text: 'Assets',
            icon: 'icons/information.png',
        });
        this.sideBar.addItem({
            id: 'rule_schedule',
            text: 'Schedule',
            icon: 'icons/information.png',
        });
        this.sideBar.addItem({
            id: 'rule_definition',
            text: 'Definition',
            icon: 'icons/information.png',
        });
        this.sideBar.addItem({
            id: 'rule_geofences',
            text: 'Geofences',
            icon: 'icons/information.png',
        });
        this.sideBar.addItem({
            id: 'rule_notification',
            text: 'Notification',
            icon: 'icons/information.png',
        });

        this.buildForms();
    }

    private buildForms(): void {
        this.descriptionForm = this.sideBar.cells('rule_description').attachForm({});
        const formData = [
            {
                type: 'settings',
                position: 'label-left',
                labelWidth: 200,
                inputWidth: 130,
            },
            {
                name: 'id',
                type: 'input',
                label: 'ID',
                value: '',
                inputWidth: '400',
                offsetLeft: '25',
                offsetTop: '25',
                disabled: true,
            },
            {
                name: 'name',
                type: 'input',
                label: 'Name',
                value: '',
                inputWidth: '400',
                offsetLeft: '25',
                validate: 'ValidAplhaNumeric',
                required: true,
            },
            {
                name: 'description',
                type: 'input',
                label: 'Description',
                value: '',
                rows: '3',
                inputWidth: '400',
                offsetLeft: '25',
            },
        ];
        this.descriptionForm.loadStruct(formData);

        this.geofenceGrid = this.sideBar.cells('rule_geofences').attachGrid();
        this.geofenceGrid.setHeader('Action,Geofence', '', []);
        this.geofenceGrid.setColTypes('coro,coro');

        const comb = this.geofenceGrid.getCombo(0);
        comb.put('INSIDE', 'Inside');
        comb.put('OUTSIDE', 'Outside');
        comb.put('ENTER', 'Enter');
        comb.put('EXIT', 'Exit');
        comb.put('BOTH', 'Both');

        this.geofenceGrid.init();
        this.geofenceGrid.addRow('1', ['', '', ''], 0, '', '', false);

        this.definitionsGrid = this.sideBar.cells('rule_definition').attachGrid();
        this.definitionsGrid.setHeader('Signal,Expression,Value', '', []);
        this.definitionsGrid.setColTypes('coro,coro,ed');

        const signalCombo = this.definitionsGrid.getCombo(0);
        signalCombo.put('INPUT_1', 'Input 1');
        signalCombo.put('INPUT_2', 'Input 2');
        signalCombo.put('INPUT_3', 'Input 3');
        signalCombo.put('INPUT_4', 'Input 4');
        signalCombo.put('INPUT_IGN', 'Ignition');
        signalCombo.put('INPUT_PLOW', 'Plow');
        signalCombo.put('INPUT_MOLDBOARD', 'Moldboard');
        signalCombo.put('INPUT_BOX', 'Box');

        const expCombo = this.definitionsGrid.getCombo(1);
        expCombo.put('LESS', '<');
        expCombo.put('MORE', '>');
        expCombo.put('EQUAL', '=');
        expCombo.put('NOT_EQUAL', '!=');

        this.definitionsGrid.init();

        this.definitionsGrid.addRow('1', ['', '', ''], 0, '', '', false);
    }
}
